<template>
  <div class="inline-flex items-center">
    <!-- Only for slot content: NotificationSettingsForm brings its own `<label for>`. -->
    <label
      v-if="$slots.default"
      :for="id ?? fallbackId"
      class="text-gray-900 mr-2 grow"
    >
      <slot />
    </label>

    <!-- `large`, like the app's two other switches. Element Plus sizes the switch outside
         $common-component-size, so the global size would leave it smaller on desktop. -->
    <ElSwitch
      :id="id ?? fallbackId"
      v-model="model"
      :disabled="disabled"
      size="large"
      class="shrink-0"
    />
  </div>
</template>

<script lang="ts" setup>
import { ElSwitch } from 'element-plus';
import { useId } from 'vue';

interface Props {
  /** Ties an outside label to the switch. Without one, the slot label gets a generated id. */
  id?: string,
  disabled?: boolean,
}

withDefaults(defineProps<Props>(), { id: undefined, disabled: false });

const model = defineModel<boolean>({ required: true });

const fallbackId = useId();
</script>
